import React, { useState, useEffect, useContext } from "react";
import Forecast, { IForecast } from "../../services/api/Forecast";
import Year, { IYear } from "../../services/api/Year";
import Month, { IMonth } from "../../services/api/Month";
import Select from "../../components/Form/Select";
import GroupList from "./components/GroupList";
import ContentHeader from "../../components/ContentHeader";
import { ReactComponent as ForecastLogo } from "../../components/ContentHeader/assets/images/forecast.svg";
import Loading from "../../components/Loading";
import "./components/assets/css/colors.css";

import AuthContext from "../../contexts/AuthContext";

const ForecastUpdate: React.FC = () => {
  const { user } = useContext(AuthContext);
  const [forecast, setForecast] = useState<IForecast[]>([]);
  const [years, setYears] = useState<IYear[]>([]);
  const [months, setMonths] = useState<IMonth[]>([]);
  const [loading, isLoading] = useState<Boolean>(true);

  const [year, setYear] = useState<Number>(0);
  const [month, setMonth] = useState<Number>(0);

  const date = new Date();

  async function LoadForecast(year: Number, month: Number) {
    const response: IForecast[] = await Forecast.GetAll(year, month);
    setForecast(response);
  }

  useEffect(() => {
    Promise.all([Year.GetAll(), Month.GetAll()])
      .then((value) => {
        const years = value[0].filter((value) => { return value.active });
        setYears(years);
        setMonths(value[1]);

        setYear(years[0].name);
        setMonth(date.getMonth() + 1);

        LoadForecast(years[0].name, date.getMonth() + 1);

        isLoading(false);
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    if (!loading) LoadForecast(year, month);
  }, [year, month]);

  function list(obj: any): any {
    return { value: obj.id, label: obj.name };
  }

  return (
    <main className="wrapperApp">
      <ContentHeader
        title="Forecast Update"
        Icon={ForecastLogo}
        breadcrumb={["Forecast Update"]}
      />
      <div id="content">
        <section className="content__block">
          {loading ? (
            <Loading />
          ) : (
            <>
              <div className="content__header">
                <h2 className="content__title">INSERT OR EDIT UNIT DATA</h2>

                <div className="multi-selects">
                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="month"
                      title="Month"
                      options={months.map(list)}
                        value={month}
                      disabled={user!.profile.name === "Sender"}
                      handleChange={(
                        event: React.FormEvent<HTMLSelectElement>
                      ) => {
                        setMonth(+event.currentTarget.value);
                      }}
                    />
                  </div>

                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="year"
                      title="Year"
                      options={years.map((obj) => {
                        return { value: obj.name, label: obj.name };
                      })}
                        value={year}
                      disabled={user!.profile.name === "Sender"}
                      handleChange={(
                        event: React.FormEvent<HTMLSelectElement>
                      ) => {
                        setYear(+event.currentTarget.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="groups edit__buttons">
                <GroupList data={forecast} year={year} month={month} />
              </div>

              <div className="forecastColors">
                <div className="forecastColors__wrapper">
                  <span className="forecastColors__dot forecastColors__dot--pendding"></span>
                  <span className="forecastColors__text">Pending</span>
                </div>
                <div className="forecastColors__wrapper">
                  <span className="forecastColors__dot forecastColors__dot--approved"></span>
                  <span className="forecastColors__text">Approved</span>
                </div>
                <div className="forecastColors__wrapper">
                  <span className="forecastColors__dot forecastColors__dot--revision"></span>
                  <span className="forecastColors__text">
                    Waiting for approval
                  </span>
                </div>
                <div className="forecastColors__wrapper">
                  <span className="forecastColors__dot forecastColors__dot--reproved"></span>
                  <span className="forecastColors__text">
                    Adjustment needed
                  </span>
                </div>
              </div>
            </>
          )}
        </section>
      </div>
    </main>
  );
};

export default ForecastUpdate;
